import { FC, ReactNode } from "react";
import { cn } from "@racoon/ui";

type Props = {
  /** Days 1..count. */
  count: number;
  selected: (day: number) => boolean;
  onToggle?: (day: number) => void;
  /** Shown under a selected day's number. */
  renderSelected?: (day: number) => ReactNode;
};

/** Days of a month, seven a row (Figma "Monthly Calendar", 22793:51109). */
export const MonthGrid: FC<Props> = ({ count, selected, onToggle, renderSelected }) => {
  const lastRow = Math.floor((count - 1) / 7) * 7;
  return (
    <div className="grid w-full grid-cols-7 overflow-hidden rounded-md border border-border-primary bg-white">
      {Array.from({ length: count }, (_, i) => i + 1).map((day) => {
        const on = selected(day);
        return (
          <div
            key={day}
            className={cn(
              "flex h-20 flex-col border-border-primary",
              day % 7 !== 0 && "border-r",
              day <= lastRow && "border-b",
              on ? "bg-surface-information-subtle" : "bg-surface-muted",
            )}
          >
            <button
              type="button"
              aria-pressed={on}
              disabled={!onToggle}
              onClick={() => onToggle?.(day)}
              className={cn(
                "flex flex-1 items-center justify-center text-sm font-bold disabled:cursor-default",
                on ? "text-text-information" : "text-text-disabled",
              )}
            >
              {day}
            </button>
            {on && renderSelected && <div className="flex px-2 pb-2">{renderSelected(day)}</div>}
          </div>
        );
      })}
    </div>
  );
};
